import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { CSSProperties } from "@material-ui/core/styles/withStyles";

export default makeStyles((theme: Theme) => {
  const detailsCell: CSSProperties = {
    padding: theme.spacing(0.5),
    display: "flex",
    alignItems: "center",
    height: "100%"
  };

  const sectionIcon: CSSProperties = {
    fontSize: "3rem !important"
  };

  return {
    root: {
      "@media print": {
        "& .no-print": {
          display: "none"
        }
      }
    },
    field: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(2)
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    sizeUnit: {
      width: theme.spacing(7)
    },
    downloadButtons: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    uploadButtons: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    fileUploadArea: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    loading: {
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      marginBottom: theme.spacing(2)
    },
    expansionPanel: {
      marginBottom: theme.spacing(1)
    },
    resultContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    image: {
      maxHeight: 150
    },
    listItemTight: {
      paddingTop: 0,
      paddingBottom: 0
    },
    productCard: {
      padding: 0,
      margin: 0,
      border: 0
    },
    productCardHeader: {
      borderBottom: "1px solid #e0e0e0",
      padding: "10px",
      marginBottom: "20px"
    },
    gridDivider: {
      paddingLeft: "8px !important",
      paddingRight: "0px !important",
      borderLeft: "1px solid #e0e0e0"
    },
    gridDividerMobile: {
      borderTop: "1px solid #e0e0e0",
      paddingTop: "8px !important",
      paddingRight: "0px !important",
      "& .MuiListItem-gutters": {
        paddingRight: "16px !important"
      }
    },
    storeList: {
      maxHeight: 300,
      position: "relative",
      overflow: "auto",
      "& .MuiListItem-gutters": {
        paddingLeft: 0,
        paddingRight: 0
      }
    },
    scanner: {
      "& > div": {
        flex: 1
      }
    },
    manualInput: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    manualInputLabel: {
      marginTop: theme.spacing(1),
      paddingLeft: 10
    },

    check: {
      color: "green",
      borderColor: "green"
    },
    cross: {
      color: "red",
      borderColor: "red"
    },
    tabPanel: {
      padding: "0 !important",
      margin: "0",
      "& .MuiIconButton-root": {
        padding: "3px"
      },
      "& .MuiToolbar-root": {
        "& .MuiFormControl-root.MuiTextField-root": {
          paddingRight: "1rem"
        },
        "& :nth-child(3) > div": {
          "& > div": {
            display: "flex"
          }
        }
      }
    },
    tabActions: {
      "& .MuiButtonBase-root.MuiIconButton-root": {
        padding: "0.2rem"
      },
      "& .MuiSvgIcon-root:not(.mediumFont)": {
        fontSize: "2rem"
      }
    },
    printableProducts: {
      "@media print": {
        top: 0,
        marginTop: 0,
        position: "absolute",
        width: "100vw"
      }
    },
    printableProduct: {
      width: "25%",
      display: "inline-block",
      paddingBottom: theme.spacing(4),
      paddingTop: theme.spacing(4),
      border: "1px solid rgb(224, 224, 224)",
      "@media print": {
        paddingBottom: "0.5cm",
        paddingTop: "0.5cm",
        breakInside: "avoid"
      }
    },
    printableProductInfo: {
      textAlign: "center",
      paddingLeft: "1rem",
      paddingRight: "1rem",

      "& :first-child": {
        paddingRight: "1rem"
      }
    },
    togglePrintable: {
      display: "flex",
      "& svg:nth-child(2n)": {
        position: "absolute",
        fontSize: "1rem",
        marginLeft: "1rem",
        marginTop: "0.6rem",
        backgroundColor: "white",
        borderRadius: "1.2rem"
      },
      "& svg.remove": {
        color: "rgb(245, 0, 87)"
      }
    },
    drawerAction: {
      display: "flex",
      paddingRight: theme.spacing(2),
      alignItems: "center"
    },
    drawerMenuCategory: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      backgroundColor: theme.palette.grey[50],
      display: "flex",
      alignItems: "center",
      "& .MuiTypography-root": {
        textIndent: theme.spacing(2)
      }
    },
    dialogTitle: {
      height: "3rem",
      display: "flex",
      alignItems: "center"
    },
    fullHeight: {
      height: "100%"
    },
    productDetails: {
      marginBottom: theme.spacing(4)
    },
    productDetailsItem: {},
    detailsCell: {
      flex: 1,
      alignSelf: "stretch",
      height: theme.spacing(5)
    },
    detailsNameColumn: {
      ...detailsCell,
      color: theme.palette.grey[700]
    },
    detailsDataColumn: {
      ...detailsCell,
      wordBreak: "break-word",
      fontWeight: theme.typography.fontWeightBold
    },
    sectionIconSuccess: {
      ...sectionIcon,
      color: theme.palette.success.dark
    },
    sectionIconPrimary: {
      ...sectionIcon,
      color: theme.palette.primary.dark
    }
  };
});
